class Twitter {
	welcome() {
		return null
	}
}

export default new Twitter();



// WEBPACK FOOTER //
// ./src/Twitter.js